export default __webpack_public_path__ + "static/media/ArrowDown.220bf3b6.svg";